module.exports = __webpack_public_path__ + "img/living.bb80a566.jpg";